import cx from 'classnames'
import styles from './index.css'

const ContentLayout = props => {
  const { isSuccessPage } = props
  return (
    <div
      className={cx(
        styles.contentLayout,
        // 批次提案完成頁因為 layout 預設 maring 的關係會有留灰底在四邊
        // 因此只在進入完成頁加上整個背景加上白色 mask
        { [styles.success]: isSuccessPage }
      )}
    >
      {props.children}
    </div>
  )
}

export default ContentLayout
